import { z } from 'zod';

import { REPROCESSING_INVOICE_FILE_TYPE } from './constants';

export const zodReprocessingInvoiceFileEndpointSchema = z.tuple([
  z.literal('invoice'),
  z.literal('process'),
  z.uuid(),
  z.literal('file'),
  z.uuid(),
]);

export const zodReprocessingInvoiceFileTypeSchema = z.enum(
  REPROCESSING_INVOICE_FILE_TYPE,
);
